import { connect } from "react-redux";
import {
  Button,
  UncontrolledAlert,
  Col,
  Row,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import React, {
  useState,
  useEffect,
} from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import FromToDate from "components/Common/Filters/FromToDate";

function Filter(props) {
  const [openCanvas, setOpenCanvas] = useState(false);
  const initValues = {
    customerId: "",
    filterDate: {
      fromDate: "",
      toDate: ""
    },
    status: "",
    currency: "",
    paid: "",
    amount: "",
    fee: "",
    gateway: "",
    tradingAccount: "",
    agent: ""
  };

  const { filteredValues = initValues } = props;
  const [values, setValues] = useState(filteredValues);

  const [filtered, setFilter] = useState(false);
  useEffect(() => {
    let f = JSON.stringify(initValues) === JSON.stringify(values);
    setFilter(!f);
  }, [values]);

  const statusOptions = ["APPROVED", "PENDING", "REJECTED"];
  const clientChangeHandler = (obj) => {
    setValues({
      ...values,
      customerId: obj.value
    });
  };

  const resetFilter = () => {
    setValues(initValues);
    // props.filteredValues = initValues;
    props.filterChangeHandler(initValues);
  };


  const dateChangeHandler = (filterDate) => {
    setValues({
      ...values,
      filterDate: filterDate
    });

  };

  const toggleCanvas = () => {
    setOpenCanvas(!openCanvas);
  };

  useEffect(() => {
    if (!props.showAddSuccessMessage && openCanvas) {
      setOpenCanvas(false);
    }
  }, [props.showAddSuccessMessage]);

  return (
    <React.Fragment>
      <Button
        color="primary"
        className={"btn btn-primary"} 
        style={{ minWidth:"fit-content" }}
        onClick={toggleCanvas}>
        <i className="bx bx-filter me-1" />
        {filtered ? props.t("Update Filter") : props.t("Advance Filter")}
      </Button>
      <Offcanvas
        isOpen={openCanvas}
        direction="end"
        scrollable
        toggle={toggleCanvas}
      >
        <OffcanvasHeader toggle={toggleCanvas}
          tag="h4">
          {props.t("Advance Filter")}
        </OffcanvasHeader>
        <OffcanvasBody>
          <AvForm
            className='p-4'
            onValidSubmit={(e, v) => {
              props.filterChangeHandler(values);
              setOpenCanvas(false);
            }}
          >
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="planName"
                    label={props.t("Plan Name")}
                    placeholder={props.t("Plan Name")}
                    type="text"
                    value={props.filteredValues["title"] || values["title"]}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "title": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="totalProfit"
                    label={props.t("Total Profit")}
                    placeholder={props.t("Total Profit")}
                    type="text"
                    value={props.filteredValues["totalProfit"] || values["totalProfit"]}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "totalProfit": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
            </Row>
            <Row>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="dailyLoss"
                    label={props.t("Daily Loss")}
                    placeholder={props.t("Daily Loss")}
                    type="text"
                    value={props.filteredValues["dailyLoss"] || values["dailyLoss"]}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "dailyLoss": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="maxLoss"
                    label={props.t("Max Loss")}
                    placeholder={props.t("Max Loss")}
                    type="text"
                    value={props.filteredValues["maxLoss"] || values["maxLoss"]}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "maxLoss": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
            </Row>

            <Row>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="minTradingDays"
                    label={props.t("Min Trading Days")}
                    placeholder={props.t("Min Trading Days")}
                    type="text"
                    value={props.filteredValues["minTradingDays"] || values["minTradingDays"]}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "minTradingDays": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="planId"
                    label={props.t("Plan ID")}
                    placeholder={props.t("Enter Plan ID")}
                    type="text"
                    errorMessage={props.t("Enter plan ID")}
                    value={props.filteredValues?.planId || values.planId}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        "recordId": e.target["value"]
                      });
                    }}

                  />
                </div>
              </Col>
            </Row>

            <div className="mb-3">
              <FromToDate
                filterDate={values.filterDate}
                dateChangeHandler={dateChangeHandler}
              />
            </div>

            <div className="row">
              <div className="col-sm-12 text-center">
                <Button disabled={!filtered} type="submit" color="primary" className="btn btn-primary btn-md center-block">
                  {props.t("Filter")}
                </Button>
                {" "}
                {" "}
                <Button onClick={resetFilter} color="primary" type="reset" className="btn btn-danger btn-md center-block">
                  {props.t("Reset")}
                </Button>
              </div>
            </div>

          </AvForm>
          {props.error && <UncontrolledAlert color="danger">
            <i className="mdi mdi-block-helper me-2"></i>
            {props.t(props.error)}
          </UncontrolledAlert>}
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => ({
  error: state.clientReducer.error,
  clientPermissions: state.Profile.clientPermissions,
  showAddSuccessMessage: state.clientReducer.showAddSuccessMessage,
  disableAddButton: state.clientReducer.disableAddButton,
  clients: state.clientReducer.clients,
  leads: state.leadReducer.leads,
});
export default connect(mapStateToProps, null)(withTranslation()(Filter));